import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  GET_UTILITY_REQUEST_CARD_STATES,
  GET_UTILITY_REQUEST_CARD_STATES_SUCCESS,
  GET_UTILITY_REQUEST_CARD_STATES_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getUtilityRequestCardStates({ payload }) {
  const cardName = payload?.cardName || 'utility_total_requests_summary_card';

  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/utility-request/card-states/${cardName}`,
      method: 'GET',
      headers: filteredHeaders,
      params: payload?.urlParams || {},
    });

    if (response.status === 200) {
      yield put({
        type: GET_UTILITY_REQUEST_CARD_STATES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_UTILITY_REQUEST_CARD_STATES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_UTILITY_REQUEST_CARD_STATES_ERROR, payload: error });
  }
}

export function* watchGetUtilityRequestCardStates() {
  yield takeEvery(GET_UTILITY_REQUEST_CARD_STATES, getUtilityRequestCardStates);
}

function* getUtilityRequestCardStatesSaga() {
  yield all([fork(watchGetUtilityRequestCardStates)]);
}

export default getUtilityRequestCardStatesSaga;
